
// Very simple module to coordinate API versioning/changes.

export default { base: '/api' };
